module.exports = __webpack_public_path__ + "img/heart_plus.92ba64b2.svg";